<template>
  <div class="floating-container" ref="containerVideo" :id="`floating-container-${uuid}`">
    <div class="header-floating-container" @mousedown="dragMouseDown">
      <span @click.stop="removeListeners" class="closeButton">
        <feather-icon icon="XIcon" size="14" class="x-icon"/>
      </span>
    </div>
    <div :class="['cam-container-floating', `cam-${cameraId}`]">
      <div v-if="uuid" :class="`camera-${uuid} video-container`"></div>
    </div>
  </div>
</template>

<script>
import CamerasSdk from "@omnicloud/cameras-sdk-v2";
import { SLOT_TYPES, SOURCES } from "@/config/layoutConfig";
import layoutMixin from "@/mixins/layoutMixin";
import { EventBus } from "@/libs/event-bus";
export default {
  mixins: [layoutMixin],
  props: {
    pos: [Number, String],
    parentId: [Number, String],
    cameraId: [Number, String],
    cameraProxyId: [Number, String],
    cameraType: String,
    dateRange: Object,
    nameSufix: String,
    host: {
      type: String,
      default: window.__env.VUE_APP_BASE_URL,
    },
    uuid: String,
    tabInfo: Object,
  },
  data() {
    return {
      camerasSdk: null,
      pos3: 0,
      pos4: 0,
      parent: null,
    };
  },
  mounted() {
    const token = localStorage.getItem("accessToken");
    this.parent = this.$refs.containerVideo.parentElement;

    try {
      if (document.fullscreen) {
        document.fullscreenElement.appendChild(this.$refs.containerVideo);
      }

      if (this.cameraId && this.cameraProxyId && this.uuid) {
        this.camerasSdk = new CamerasSdk(this.getCameraConfig(token));
      }

      EventBus.on("entering-full-screen", this.enteringFullScreen);
      EventBus.on("exiting-full-screen", this.exitingFullScreen);
      EventBus.on(`setLang`, this.onSetLang);
    } catch (e) {
      console.error(e);
    }
  },
  beforeUnmount() {
    EventBus.off(`setLang`, this.onSetLang);
    this.removeListeners();
    if (this.camerasSdk) {
      this.camerasSdk.getPlayer()?.destroy();
      this.camerasSdk = null;
    }
  },
  methods: {
    onSetLang(lang) {
      this.camerasSdk?.setLang(lang);
    },
    getCameraConfig(token) {
      return {
        id: this.uuid,
        cameraId: this.cameraProxyId,
        container: `.camera-${this.uuid}`,
        token,
        apiUrl: `${this.host}/v1`,
        pusher_app_key: window.__env?.VUE_APP_LARAVEL_PUSHER_APP_KEY,
        pusher_host: window.__env?.VUE_APP_LARAVEL_PUSHER_HOST,
        pusher_port: window.__env?.VUE_APP_LARAVEL_PUSHER_PORT,
        pusher_app_cluster: window.__env.VUE_APP_LARAVEL_PUSHER_APP_CLUSTER || "mt1",
        startDate: this.dateRange?.startDate || null,
        endDate: this.dateRange?.endDate || null,
        mode:
          this.dateRange?.startDate && this.dateRange?.endDate
            ? "recorded_video"
            : "live_video",
        lang: this.$i18n.locale,
      };
    },
    enteringFullScreen(slot) {
      document.querySelector(`#${slot.id}`).appendChild(this.$refs.containerVideo);
    },
    exitingFullScreen() {
      this.parent.appendChild(this.$refs.containerVideo);
    },
    removeListeners() {
      if (this.camerasSdk && typeof this.camerasSdk.off === "function") {
        this.camerasSdk.getPlayer()?.destroy();
      }
      this.$emit("destroy", { id: this.cameraId, type: this.cameraType });
    },
    dragMouseDown(e) {
      e.preventDefault();
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      document.onmouseup = this.closeDragElement;
      document.onmousemove = this.elementDrag;
    },
    elementDrag(e) {
      e.preventDefault();

      const pos1 = this.pos3 - e.clientX;
      const pos2 = this.pos4 - e.clientY;
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;

      const container = this.$refs.containerVideo;
      container.style.top = `${Math.max(
        0,
        Math.min(
          window.innerHeight - container.offsetHeight - 10,
          container.offsetTop - pos2
        )
      )}px`;
      container.style.left = `${Math.max(
        0,
        Math.min(
          window.innerWidth - container.offsetWidth - 10,
          container.offsetLeft - pos1
        )
      )}px`;
    },

    closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.floating-container {
  position: absolute;
  min-height: 10rem;
  min-width: 15rem;
  width: 25vw;
  top: 0;
  left: 0;
  background: black;
  z-index: 15;
  resize: both;
  overflow: hidden;

  span {
    cursor: pointer;
    margin-right: 0.1rem;
  }

  div[class^="camera-"] {
    height: 100%;
  }

  .cam-container-floating {
    width: 100%;
    height: 100%;
    position: absolute;
  }
}

.header-floating-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2rem;
  z-index: 15;
  display: flex;
  justify-content: flex-end;
}

.closeButton {
  z-index: 16;
}
.x-icon {
  color: rgb(154, 154, 154);
  cursor: pointer;
  &:hover {
    color: white;
  }
}
</style>
